export default __webpack_public_path__ + "static/Connect-655297f42e8d561e6162c9953a6871a8.png";